import { createSelector } from 'reselect';
import { BusinessUnitLandingPageWidgetsTemplateSelector, BusinessUnitHasTemplateSelector, BusinessUnitTemplateSelector } from 'invision-core/src/components/configurable/configurable.selectors';
var EMPTY_ARRAY = [];
export var LandingPageTemplateSelector = createSelector([BusinessUnitHasTemplateSelector, BusinessUnitTemplateSelector], function (hasTemplate, businessUnitTemplate) {
  return hasTemplate ? businessUnitTemplate.landingPageWidgets : null; // TODO determine if we need a default
});
export var LandingPageWidgetsSelector = createSelector([LandingPageTemplateSelector, BusinessUnitLandingPageWidgetsTemplateSelector], function (landingPageTemplate, landingPageWidgets) {
  if (landingPageTemplate === null || landingPageTemplate === undefined || landingPageTemplate.length === 0 || landingPageWidgets.length === 0) {
    return EMPTY_ARRAY;
  }
  return landingPageTemplate.map(function (widgetId) {
    return Object.values(landingPageWidgets).find(function (widget) {
      return widget.Id === widgetId;
    });
  });
});